import { ApiClient } from "./apiClient";
import { ApiResponse } from "./types";
import { appConfig } from "../config";

export interface Tenant {
    id: string;
    companyName: string;
    locale: string;
    currency: string;
    timezone: string;
    dateFormat: string;
    timeFormat: string;
    numberFormat: string;
    standardWeeklyWorkingHours: number;
}

export type UpdateTenantRequest = Partial<Omit<Tenant, 'id'>>;

const apiClient = new ApiClient(`${appConfig.backendUrl}/api/tenants`);

/**
 * Fetch the current tenant information
 */
export const fetchTenant = (): Promise<ApiResponse<Tenant>> => {
    return apiClient.get<Tenant>('');
};

/**
 * Update tenant information
 */
export const updateTenant = (tenantData: UpdateTenantRequest): Promise<ApiResponse<Tenant>> => {
    return apiClient.put<Tenant>('', tenantData);
};